import { Modal, ModalProp } from "../../components/modal/Modal";
import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";

export type ExecutionCompleteModalProps = {
  executionErrFlg: boolean;
}

export const ExecutionCompleteModal = ({
  open,
  toggle,
  closeOnClickOutside,
  executionErrFlg,
}: ModalProp & ExecutionCompleteModalProps) => {

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:w-full max-w-screen-md">
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title as="h3" className="text-left text-lg font-medium leading-6 text-gray-900">
                {executionErrFlg ? <>登録が完了しましたが一部エラーがあります</>:<>登録が完了しました</>}
              </Dialog.Title>
            </div>
            <div className="mt-5">
              {executionErrFlg ? <>詳細画面で内容を確認してください。</>:<></>}
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-36"
              onClick={toggle}
              children={"閉じる"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  );
};